module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/msysov8-f2b213e812b3057e887595305ad0feb5.jpg";